import { render, staticRenderFns } from "./CharacterBlacklistItem.vue?vue&type=template&id=0d08ea02&scoped=true&"
import script from "./CharacterBlacklistItem.vue?vue&type=script&lang=js&"
export * from "./CharacterBlacklistItem.vue?vue&type=script&lang=js&"
import style0 from "./CharacterBlacklistItem.vue?vue&type=style&index=0&id=0d08ea02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d08ea02",
  null
  
)

export default component.exports